module.exports = __webpack_public_path__ + "7200d2ec304a4d3f73f831cae8814e83.svg";